<div class="my-10 px-4 flex overflow-hidden">
  <div class="rounded-lg border-r bg-background flex flex-col h-[calc(100vh-5rem)] w-[30%]">
    <div class="p-4 border-b shrink-0">
      <div class="flex items-center justify-between">
        <h2 class="text-lg font-semibold" i18n="@@tituloCard">Modelo de datos</h2>
        <div class="flex gap-2">
          <button class="p-1.5 rounded-md hover:bg-muted" pButton [pTooltip]="refreshSTR" (click)="refreshModel()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 2v6h-6"></path>
              <path d="M3 12a9 9 0 0 1 15-6.7l3 2.7"></path>
              <path d="M3 22v-6h6"></path>
              <path d="M21 12a9 9 0 0 1-15 6.7l-3-2.7"></path>
            </svg>
          </button>
          <button class="p-1.5 rounded-md hover:bg-muted" pButton [pTooltip]="saveModelSTR" (click)="dataModelService.sendModel()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
              <polyline points="17 21 17 13 7 13 7 21"></polyline>
              <polyline points="7 3 7 8 15 8"></polyline>
            </svg>
          </button>
          <button class="p-1.5 rounded-md hover:bg-muted" pButton [pTooltip]="saveAsModelSTR" (click)="dataModelServiceSaveAs()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <rect x="3" y="3" width="13" height="13" rx="2" ry="2"></rect>
            </svg>
          </button>
          @if(['excel','csv'].includes(connectionType)){
            <button class="p-1.5 rounded-md hover:bg-muted" pButton [pTooltip]="updateModelXLCSV" (click)="openUpdateFilePage()">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                <path d="M3 5v3c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
                <path d="M3 8v3c0 1.66 4 3 9 3s9-1.34 9-3V8"></path>
                <path d="M3 11v3c0 1.66 4 3 9 3s9-1.34 9-3v-3"></path>
                <path d="M3 14v3c0 1.66 4 3 9 3s9-1.34 9-3v-3"></path>
              </svg>
            </button>
          }@else{
            <button class="p-1.5 rounded-md hover:bg-muted" pButton [pTooltip]="updateModelSTR" (click)="reLoadModelFromDb()">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                <path d="M3 5v3c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
                <path d="M3 8v3c0 1.66 4 3 9 3s9-1.34 9-3V8"></path>
                <path d="M3 11v3c0 1.66 4 3 9 3s9-1.34 9-3v-3"></path>
                <path d="M3 14v3c0 1.66 4 3 9 3s9-1.34 9-3v-3"></path>
              </svg>
            </button>
          }
          <button class="p-1.5 rounded-md hover:bg-muted" pButton [pTooltip]="deleteModelSTR" (click)="deleteDatasource()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 6h18"></path>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>
              <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="px-3 py-2 border-b shrink-0">
      <div class="flex items-center gap-2 rounded-md border px-2 py-1 bg-muted/40">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-muted-foreground shrink-0">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <input class="bg-transparent text-sm outline-none w-full placeholder:text-muted-foreground"
          type="text"
          i18n-placeholder="@@buscarTabla"
          placeholder="Buscar..."
          (input)="searchTerm = $any($event.target).value" />
      </div>
    </div>

    <div class="p-2 overflow-auto flex-1">
      <p-tree id="datasource-list" [style]="{'width':'100%'}" [value]="filteredTreeData" [filter]="false"
        selectionMode="single" [(selection)]="selectedFile" (onNodeSelect)="nodeSelect($event)"
        (onNodeUnselect)="nodeUnselect($event)" (onNodeExpand)="nodeSelect($event)">
        <ng-template let-node pTemplate="selected">
          <div class="font-bold text-corporate-primary">{{node.label}}</div>
        </ng-template>
        <ng-template let-node pTemplate="unselected">
          <div class="font-light">{{node.label}}</div>
        </ng-template>
      </p-tree>
    </div>
  </div>

  <div class="w-[70%] h-[calc(100vh-5rem)] overflow-auto">
    <app-data-source-detail (onTableCreated)="reLoadModelFromDb()"></app-data-source-detail>
  </div>
  
  @if (isSaveAsDialogVisible) {
    <app-datasource-save-as (close)="saveDatasourceAs($event)"></app-datasource-save-as>
  }
</div>